module.exports = __webpack_public_path__ + "static/media/eh.18b9b9fc.svg";